import React from 'react';

import { useMediaQuery, useTheme } from '@mui/material';
import dayjs from 'dayjs';

import { useGetCurrentUserQuery } from '../../../services/users';

import {
  WelcomeCardContainer, WelcomeName, WelcomeText, WelcomeTitle,
} from './index.styles';

// Greetings based on time of day
const getGreeting = () => {
  const currentTime = dayjs();
  const currentHour = currentTime.hour();
  if (currentHour >= 2 && currentHour < 4) {
    return 'Time to sleep';
  }
  if (currentHour >= 4 && currentHour < 12) {
    return 'Good morning';
  }
  if (currentHour >= 12 && currentHour < 18) {
    return 'Good afternoon';
  }
  return 'Good evening';
};

const WelcomeCard = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'));

  const { data: currUser } = useGetCurrentUserQuery();

  return (
    <WelcomeCardContainer>
      <WelcomeTitle variant={isMd ? 'h2' : 'h4'}>{getGreeting()}, <WelcomeName>{currUser?.data.firstName}!</WelcomeName></WelcomeTitle>
      <WelcomeText variant={isMd ? 'h5' : 'h6'}>Welcome to Cognito Online 😊</WelcomeText>
    </WelcomeCardContainer>
  );
};

export default WelcomeCard;
